import { OrderBookType } from '../../config/constants';

type TPSLOrder = OrderBookType.TAKE_PROFIT | OrderBookType.STOP_LOSS;

const isTpslOrder = (status: OrderBookType): status is TPSLOrder => {
    return [OrderBookType.TAKE_PROFIT, OrderBookType.STOP_LOSS].includes(status);
};

export default isTpslOrder;
